import { render, staticRenderFns } from "./Vulnerabilities.vue?vue&type=template&id=4a8a1bf0&scoped=true&"
import script from "./Vulnerabilities.vue?vue&type=script&lang=js&"
export * from "./Vulnerabilities.vue?vue&type=script&lang=js&"
import style0 from "./Vulnerabilities.vue?vue&type=style&index=0&id=4a8a1bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a1bf0",
  null
  
)

export default component.exports